import { useState } from "react";

export default () => {
  const [values, setValues] = useState({
    publishBlocked: false,
    connectedDevices: 0,
  });

  return [values, setValues];
};
